/**
 * Walk a screen / form config tree and return true if any node declares ExpressionV2.
 * Accepts a single component, a Fields/childComponents array, or a full screen config array.
 */
export function screenHasExpressionV2(config: unknown): boolean {
  if (!config) return false;
  if (Array.isArray(config)) {
    return config.some((node) => screenHasExpressionV2(node));
  }
  if (typeof config !== "object") return false;

  const node = config as Record<string, unknown>;
  if (typeof node.ExpressionV2 === "string" && node.ExpressionV2.length > 0) {
    return true;
  }
  const nestedKeys = [
    "Fields",
    "childComponents",
    "childControls",
    "FooterControls",
  ] as const;
  for (const key of nestedKeys) {
    const children = node[key];
    if (Array.isArray(children) && screenHasExpressionV2(children)) {
      return true;
    }
  }
  return false;
}

/** SubModule (or similar) has ExpressionV2 on childControls and/or FooterControls. */
export function componentHasExpressionV2(config: unknown): boolean {
  return screenHasExpressionV2(config);
}
